/**
 * Crude check to see if the device is a touch screen.
 * @see http://stackoverflow.com/a/4819886/556609
 *
 * @returns {boolean}
 */
export function isTouch() {
    return ('ontouchstart' in window || !!navigator.maxTouchPoints);
}

/**
 * Crude check to see if the browser is IE.
 *
 * @param version - Optionally check a specific version (11, 10, or 9)
 * @returns {boolean}
 */
export function isIE(version = null) {
    const ua = navigator.userAgent;
    const is11 = /rv:11\.0/i.test(ua);
    const is10 = /MSIE 10/i.test(ua);
    const is9 = /MSIE 9/i.test(ua);

    switch (version) {
        case 11: return is11;
        case 10: return is10;
        case  9: return is9;
    }

    return is11 && is10 && is9;
}

/**
 * Crude check to see if the browser is Safari.
 *
 * @returns {boolean}
 */
export function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}



// WEBPACK FOOTER //
// ./source/scripts/utils/inspection.js